import { useContext, useMemo } from 'react';
import ToastContext from '../../../providers/ToastProvider';

function UseToast() {
  const context = useContext(ToastContext);

  return useMemo(
    () => ({ addToast: context.addToast, removeToast: context.removeToast }),
    [context],
  );
}

export default UseToast;
